import { http } from '@/api/http';
import type {
  BadgesResponse,
  CreateGameParams,
  PracticeFinishResult,
  PracticeGameDetail,
  PracticeGameSummary,
  PracticeResult,
  PracticeTheme,
} from './types';

/**
 * Client API Practice Arena — wrap les 7 endpoints REST de `PracticeRoutes`.
 */

export const practiceApi = {
  listThemes: () => http.get<{ count: number; themes: PracticeTheme[] }>('/api/v1/practice/themes'),

  createGame: (params: CreateGameParams) =>
    http.post<{ ok: true; id: number }>('/api/v1/practice/games', params),

  listGames: (params: { limit?: number; offset?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.limit !== undefined) qs.set('limit', String(params.limit));
    if (params.offset !== undefined) qs.set('offset', String(params.offset));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return http.get<{
      count: number;
      limit: number;
      offset: number;
      games: PracticeGameSummary[];
    }>(`/api/v1/practice/games${suffix}`);
  },

  findGame: (gameId: number) =>
    http.get<PracticeGameDetail>(`/api/v1/practice/games/${gameId}`),

  recordMove: (
    gameId: number,
    payload: { ply: number; san: string; uci: string; time_spent_ms: number },
  ) =>
    http.post<{ ok: true; inserted: boolean }>(
      `/api/v1/practice/games/${gameId}/move`,
      payload,
    ),

  finishGame: (
    gameId: number,
    payload: { result: PracticeResult; final_fen?: string; pgn?: string },
  ) =>
    http.post<PracticeFinishResult>(`/api/v1/practice/games/${gameId}/finish`, payload),

  listBadges: () => http.get<BadgesResponse>('/api/v1/practice/badges'),
};
